import { Box, Flex, Icon, Text, Image, useColorModeValue } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React from "react";
import Footer from "components/footer/FooterAuth";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import LanguageSwitcher from "components/languageSwitcher/LanguageSwitcher";
import fkg from "assets/img/fkg.png"
import rsgm from "assets/img/rsgm.webp"
// Custom components
import { NavLink } from "react-router-dom";
// Assets
import { FaChevronLeft } from "react-icons/fa";

function AuthIllustration(props) {
  const { children, illustrationBackground } = props;
  const switcherBg = useColorModeValue("white", "navy.800");
  const switcherBorder = useColorModeValue("gray.200", "whiteAlpha.200");
  // Chakra color mode
  return (
    <Flex position='relative' h='max-content'>
      <Flex
        h={{
          sm: "initial",
          md: "unset",
          lg: "100vh",
          xl: "97vh",
        }}
        w='100%'
        maxW={{ md: "66%", lg: "1313px" }}
        mx='auto'
        pt={{ sm: "50px", md: "0px" }}
        px={{ lg: "30px", xl: "0px" }}
        ps={{ xl: "70px" }}
        justifyContent='start'
        direction='column'>
        <Flex
          justifyContent='space-between'
          alignItems='center'
          w='100%'
          mt='40px'
          ps={{ base: "25px", lg: "0px" }}
          pe={{ base: "25px", lg: "30px" }}>
          <NavLink
            to='/admin'
            style={() => ({
              width: "fit-content",
            })}>
            <Flex
              align='center'
              w='fit-content'>
              <Image
                src={fkg}
                width={100}
              />
              <Image
                src={rsgm}
                width={100}
              />
            </Flex>
          </NavLink>
          <Box
            bg={switcherBg}
            border='1px solid'
            borderColor={switcherBorder}
            borderRadius='14px'
            p='4px 8px'
            boxShadow='0px 4px 14px rgba(0, 0, 0, 0.06)'
            zIndex='10'>
            <LanguageSwitcher showLabel={true} />
          </Box>
        </Flex>
        {children}
        <Box
          display={{ base: "none", md: "block" }}
          h='100%'
          minH='100vh'
          w={{ lg: "50vw", "2xl": "44vw" }}
          position='absolute'
          right='0px'>
          <Flex
            bg={`url(${illustrationBackground})`}
            justify='center'
            align='end'
            w='100%'
            h='100%'
            bgSize='cover'
            bgPosition='50%'
            position='absolute'
            borderBottomLeftRadius={{ lg: "120px", xl: "200px" }}></Flex>
        </Box>
        <Footer />
      </Flex>
      <FixedPlugin />
    </Flex>
  );
}
// PROPS

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
